
    const RETRY_KEY = 'app-bootstrap-retries';
    const MAX_RETRIES = 3;

    function getRetryCount() {
      try { return parseInt(sessionStorage.getItem(RETRY_KEY) || '0', 10); }
      catch { return 0; }
    }

    function setRetryCount(count) {
      try { sessionStorage.setItem(RETRY_KEY, String(count)); }
      catch { /* storage unavailable - retry will still fire */ }
    }

    function clearRetryCount() {
      try { sessionStorage.removeItem(RETRY_KEY); }
      catch { /* storage unavailable - nothing to clear */ }
    }

    function handleBootstrapFailure(error) {
      const retries = getRetryCount();
      if (retries < MAX_RETRIES) {
        setRetryCount(retries + 1);
        console.warn(`App failed to start (attempt ${retries + 1}/${MAX_RETRIES}), reloading...`);
        setTimeout(() => location.reload(), 1000);
      } else {
        clearRetryCount();
        console.error('React app failed to start after retries:', error);
      }
    }

    if (window.configLoaded) {
      window.configLoaded
        .then(() => import('/src/main.tsx'))
        .then(() => clearRetryCount())
        .catch(handleBootstrapFailure);
    } else {
      console.warn('configLoaded promise missing; starting React immediately');
      import('/src/main.tsx')
        .then(() => clearRetryCount())
        .catch(handleBootstrapFailure);
    }
  